/**
 * Generic placeholder to use for all images.
 */
export const placeholderImageUrl = `https://tokyojob-public.s3.ap-northeast-1.amazonaws.com/public/placeholder.webp`
